import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiPostDamage = sinisterBody => {
    return httpClient.post('damages/', sinisterBody)
        .then(data => data)
}

export const apiPatchDamage = sinisterBody => {
    return httpClient.post('damages/update', sinisterBody)
        .then(data => data)
}

export const apiGetDamage = sinisterId => {
    const params = new URLSearchParams()
    if (sinisterId) {
        params.set('sinister_id', sinisterId)
    }
    return httpClient.get(`damages/resume${paramsToString(params)}`)
        .then(data => data)
}

export const apiDeleteDamage = (sinisterId, damageId) => {
    const params = new URLSearchParams()
    if (sinisterId) {
        params.set('sinister_id', sinisterId)
    }
    return httpClient.post(`damages/${damageId}${paramsToString(params)}`)
        .then(data => data)
}

export const apiPostDamageUptec = sinisterBody => {
    return httpClient.post('furniture/upptec/damage', sinisterBody)
        .catch(error => {
            const errorCodes = [400, 500, 409]
            const errorCode = errorCodes.find(errorCode => error.response.status === errorCode) || 0

            return Promise.reject(errorCode)
        })
}

export const apiGetReparationType = (damageId, repType) => {
    return httpClient.post(`damages/repType`, { damage_id: damageId, rep_type: repType })
        .then(data => data)
}